import Player from "./component/player";

export default function App() {
  return (
    <div className="App">
      <Player />
    </div>
  );
}
